import { useEffect, type RefObject } from 'react';

export const useOnClickOutside = <T extends HTMLElement = HTMLElement>(
  ref: RefObject<T>,
  handler: (event: MouseEvent | TouchEvent) => void,
) => {
  useEffect(() => {
    let clickStartedInside = false;

    const mouseDownListener = (event: MouseEvent | TouchEvent) => {
      if (!ref.current) return;
      clickStartedInside = ref.current.contains(event.target as Node);
    };

    const mouseUpListener = (event: MouseEvent | TouchEvent) => {
      if (!ref.current) return;
      if (clickStartedInside) {
        clickStartedInside = false;
        return;
      }
      if (ref.current.contains(event.target as Node)) return;

      handler(event);
      clickStartedInside = false;
    };

    document.addEventListener('mousedown', mouseDownListener);
    document.addEventListener('mouseup', mouseUpListener);
    document.addEventListener('touchstart', mouseDownListener);
    document.addEventListener('touchend', mouseUpListener);

    return () => {
      document.removeEventListener('mousedown', mouseDownListener);
      document.removeEventListener('mouseup', mouseUpListener);
      document.removeEventListener('touchstart', mouseDownListener);
      document.removeEventListener('touchend', mouseUpListener);
    };
  }, [ref, handler]);
};
